<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>销售管理</el-breadcrumb-item>
      <el-breadcrumb-item>修改消费单</el-breadcrumb-item>
      <br>
      <div style="margin-top:20px;width: 100%"  v-if="authorities.includes('sales.order.update.yizhi')">
        <el-date-picker
          v-model="value1"
          type="date"
          size="mini"
          placeholder="订单日期"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <div style="margin-top:10px;" v-if="updateCustomerCard !== null">
        <span>卡别信息：</span>
      </div>
      <el-card v-if="updateCustomerCard !== null">
        <div >
          <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
            <div style="width: 50%">
              <span style="width: 20%">卡别名称：</span>
              <el-input v-model="updateCustomerCard.cardTypeName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">所属门店：</span>
              <el-input v-model="updateCustomerCard.shopName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
            <div style="width: 50%">
              <span style="width: 20%">会员等级：</span>
              <el-input v-model="updateCustomerCard.cardLevelName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">适用项目：</span>
              <el-input v-model="updateCustomerCard.useTypeName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-between; width: 100%; margin-top: 10px;"
               v-if="updateCustomerCard.cardType < 3">
            <div style="width: 50%">
              <span style="width: 20%">账户余额：</span>
              <el-input v-model="updateCustomerCard.balance" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">卡有效期：</span>
              <el-input v-model="updateCustomerCard.validDate" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div v-if="updateCustomerCard.cardType === 2">
            <div style="width: 50%" >
              <span style="width: 20%">赠送金额：</span>
              <el-input v-model="updateCustomerCard.giveBalance" readonly size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-between; width: 100%; margin-top: 10px;"
               v-if="updateCustomerCard.cardType === 3">
            <div style="width: 50%">
              <span style="width: 20%">可用次数：</span>
              <el-input v-model="updateCustomerCard.cardNum" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">卡有效期：</span>
              <el-input v-model="updateCustomerCard.validDate" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
        </div>
      </el-card>
      <div style="margin-top:10px;">
        <span>消费明细：</span>
      </div>
      <el-card>
        <el-table :data="updateOrderDetailList" fit border stripe="stripe" width="100%"
                  :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            prop="consumptionName"
            label="项目名称" width="150">
          </el-table-column>
          <el-table-column
            align="center"
            prop="dia"
            label="直径" width="160"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="num"
            label="数量/次数" width="160"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="price"
            label="标准价格" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="vipPrice"
            label="会员价格" v-if="isCustomerOrder === true">
          </el-table-column>
          <el-table-column
            align="center"
            label="金额小计">
            <template slot-scope="scope">
              {{ (scope.row.received - scope.row.giveBalancePay).toFixed(2)}}
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <div style="margin-top:10px;display: flex;justify-content: space-between;align-items: flex-end">
        <span>服务人员：</span>
        <el-button size="mini" plain @click="showServerDialog">添加服务人员</el-button>
      </div>
      <el-card>
        <el-table :data="selectServerList" fit border stripe="stripe" width="100%" :header-cell-style="{background:'#eff3f8', color:'#000000'}"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            label="操作" width="100">
            <template slot-scope="scope">
              <el-link type="danger" icon="el-icon-delete"
                       @click="deleteServerShowList(scope.$index, selectServerList)"></el-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="userName"
            label="服务人员">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机">
          </el-table-column>
          <el-table-column
            align="center"
            label="提成比例">
            <template slot-scope="scope">
              <el-input v-model="scope.row.rate" size="mini"
                        onkeyup="value=value.replace(/[^\d.]/g,'')"
                        @change="setHyOrderUserRate"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <div style="margin-top: 10px">
        <span>金额信息：</span>
      </div>
      <el-card >
        <div style="display: flex;justify-content: space-between;align-items:center;width: 100%;">
          <div>
            <span >应收金额：</span>
            <el-input v-model="updateOrderDetail.orderReceivable" readonly  placeholder="请输入内容"  size="mini" style="width: 60%;"/>
          </div>
          <div v-if="isCustomerOrder === true">
            <span style="width: 10%;margin-left: 5px;">会员优惠：</span>
            <el-input v-model="updateOrderDetail.orderDiscounts" readonly  placeholder="请输入内容" size="mini" style="width: 60%;"/>
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">抹零金额：</span>
            <el-input v-model="updateOrderDetail.moLing"  readonly  placeholder="请输入内容" size="mini" style="width: 60%;" />
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">凑整金额：</span>
            <el-input v-model="updateOrderDetail.couZheng"  readonly  placeholder="请输入内容" size="mini" style="width: 60%;" />
          </div>
          <div v-if="updateOrderDetail.isArr === 1">
            <span style="width: 10%;margin-left: 5px;">欠款金额：</span>
            <el-input v-model="updateOrderDetail.arrearageMoney"  readonly  placeholder="请输入内容" size="mini" style="width: 60%;" />
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;"> 实收金额：</span>
            <el-input v-model="updateOrderDetail.orderReceived" readonly  placeholder="请输入内容" size="mini" style="width: 60%;" />
          </div>
        </div>
      </el-card>
      <div style="margin-top: 10px">
        <span>支付方式：</span>
      </div>
      <el-card>
        <div  style="width:100%;">
          <div  v-for="(item, index) in orgPayTypeList" :key="index" style="display: inline-block; width: 25%;margin-top: 10px" >
            <span style="display: inline-block; width: 80px;text-align: right"> {{item.payCnName}}:</span>
            <el-input v-model="item.money"
                      placeholder="请输入内容" size="mini" style="width: 100px;margin-right: 10px;"
                      :readonly="item.payEnName === 'zengsonghuiyuan' || item.payEnName == 'douyintuangou'
                      || item.payEnName == 'meituantuangou' || item.payEnName == 'koubeituangou'
                      || item.payEnName == 'xiaochengxutuangou' || item.payEnName === 'huiyuan'
                      || item.payEnName === 'kuaishoutuangou'"
                      @change="changeOrderPay" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
            <br>
          </div>
        </div>
      </el-card>
      <div style="margin-top: 10px">
        <span style="width: 10%;"> 备注说明：</span>
      </div>
      <el-card>
        <el-input v-model="updateOrderDetail.comment" type="textarea" placeholder="请输入内容" size="mini" />
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeUpdateOrderDialog">取 消</el-button>
        <el-button size="mini" @click="updateOrder">确 定</el-button>
      </span>

      <!-- 选择服务人员 -->
      <el-dialog
        title="服务人员列表"
        size="400px"
        :visible.sync="serverDialogVisible"
        :before-close="closeServerDialog"
      >
        <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
        <el-table :data="serverList" fit border stripe="stripe" width="100%"  size="mini"
                  :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  @selection-change="serverSelectChange">
          <el-table-column
            align="center"
            type="selection"
            width="60">
          </el-table-column>
          <el-table-column
            align="center"
            prop="userName"
            label="服务人员姓名">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机">
          </el-table-column>
        </el-table>
      </el-dialog>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  data(){
    return{
      areaId: window.sessionStorage.getItem('areaId'),
      currentOrgId: window.sessionStorage.getItem('currentOrgId'),
      userId: window.sessionStorage.getItem("userId"),
      authorities: window.sessionStorage.getItem('authorities'),
      orgLevel: window.sessionStorage.getItem('orgLevel'),
      moLingRate: window.sessionStorage.getItem('moLingRate'),
      orgName: window.sessionStorage.getItem('orgName'),
      value1:'',
      updateOrderDetail:'',
      updateCustomerCard:'',
      //订单详情窗口
      updateOrderDetailList:[],
      isCustomerOrder:false,
      selectServerList:[],
      orgPayTypeList:[],
      orderPayTypeTotalMoney:[],
      orderPayTypeList:[],
      serverList:[],
      serverDialogVisible:false,
      lockDate:'',
      pickerOptions: {
        disabledDate: this.disabledDate
      }
    }
  },
  methods:{
    showServerDialog(){
      this.loadServer();
      this.serverDialogVisible = true;
    },
    async loadServer(){
      const {data:res} = await this.$http.get(`/users/valida/${2}/orgId/${this.currentOrgId}/pageNum/1/pageSize/99`)
      this.serverList = res.data.list;
    },
    closeServerDialog(){
      this.resetHyOrderUserRate();
      this.serverDialogVisible = false;
    },
    deleteServerShowList(index,rows){
      rows.splice(index, 1);
      this.resetHyOrderUserRate();
    },
    setHyOrderUserRate(){
      let rateTotal = 0;
      this.selectServerList.map((item, index) =>{
        if (index === this.selectServerList.length-1){
          let rate = 100 - rateTotal;
          if (rate <= 0){
            item.rate = 0;
          } else {
            item.rate = rate.toFixed(2);
          }
        } else {
          rateTotal += item.rate - 0;
        }
      })
    },
    closeUpdateOrderDialog(){
      this.$router.go(-1)
    },
    async updateOrder(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      this.updateOrderDetail.orderPayTypeList = this.orgPayTypeList;
      this.updateOrderDetail.servers = this.selectServerList;
      let payAmount = 0;
      this.orgPayTypeList.map((item)=>{
        if(item.payEnName !== 'zengsonghuiyuan'){
          payAmount += item.money - 0;
        }
      })
      if (this.updateOrderDetail.orderReceived !== payAmount){
        this.$message.warning("支付金额与实收金额不一致！请仔细检查支付金额！")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return;
      }
      this.updateOrderDetail.orderDate = this.value1;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/order/update`,this.updateOrderDetail);
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      await this.$router.push('/orders')
    },
    resetHyOrderUserRate(){
      let rateTotal = 0;
      if (this.selectServerList.length > 0){
        this.selectServerList.map((item, index) => {
          if (index === this.selectServerList.length -1){
            let rate = 100 - rateTotal;
            item.rate = rate.toFixed(2)
          } else {
            item.rate = (100 / this.selectServerList.length).toFixed(2);
            rateTotal += item.rate - 0;
          }
        })
      }
    },
    async loadOrderDetail(data){
      const {data:res} = await this.$http.get('load/order/detail/mini/all', {params:{orderId: data}})
      this.isCustomerOrder = res.data.customerId > 0;
      this.updateOrderDetail = res.data;
      this.value1 = res.data.orderDate;
      this.updateOrderDetailList = res.data.details;
      this.selectServerList = res.data.servers;
      let orderPayType = res.data.orderPayTypeList;
      this.orgPayTypeList.map((item) => {
        orderPayType.map((index) => {
          if (index.payEnName === item.payEnName) {
            item.money = index.money - 0;
          }
        })
      })
      this.updateCustomerCard = res.data.customerCard;
      if(this.updateCustomerCard != null){
        this.getCardLevelName(this.updateCustomerCard);
      }
      // const {data:res} = await this.$http.get(`/orderDetail/orderId/${data.id}`)
      // this.orderDetailList = res.data;
      // const {data:res1} = await this.$http.get(`/order/payType/orderId/${data.id}`)
      // this.orderPayTypeList = res1.data;
      // const {data:res2} = await this.$http.get(`/load/one/customerCard/${data.cardId}`)
      // this.updateCustomerCard = res2.data;
      // let orderPayType = res1.data;
      // this.clearOrderPayType();
      // this.orgPayTypeList.map((item) => {
      //   orderPayType.map((index) => {
      //     if (index.payEnName === item.payEnName){
      //       item.money = index.money - 0;
      //     }
      //   })
      // })
      // if(data.cardId > 0){
      //   const {data:res2} = await this.$http.get(`/load/one/customerCard/${data.cardId}`)
      //   this.updateCustomerCard = res2.data;
      //   this.getCardLevelName(this.updateCustomerCard);
      // }
      //
    },
    getCardLevelName(customerCard){
      if (customerCard.cardLevel === 0){
        customerCard.cardLevelName = '普通会员';
      }
      if (customerCard.cardLevel === 1){
        customerCard.cardLevelName = '钻石会员';
      }
      if (customerCard.cardLevel === 2){
        customerCard.cardLevelName = '铂金会员';
      }
      if (customerCard.cardLevel === 3){
        customerCard.cardLevelName = '黄金会员';
      }
      if (customerCard.cardLevel === 4){
        customerCard.cardLevelName = '大众会员';
      }
    },
    async loadOrgPayType(){
      const {data:res} = await this.$http.get(`/payType/orgPayType/orgId/${this.currentOrgId}`)
      this.orgPayTypeList = res.data;
    },

    async loadOrderPayTypeTotalMoney(){
      const {data:res} = await this.$http.get(`/order/payTypeTotal/orgId/${this.currentOrgId}`)
      this.orderPayTypeTotalMoney = res.data;
    },
    changeOrderPay(){
      if (this.isCustomerOrder){
        this.setHyUpdateOrderPay();
      } else {
        this.setSkUpdateOrderPay();
      }
    },
    setHyUpdateOrderPay(){
      let kuaishoutuangou = 0;
      let douyintuangou = 0;
      let meituantuangou=0;
      let koubeituangou=0;
      let xiaochengxutuangou=0;
      let huiyuan = 0;
      let money = 0;
      let needPay = 0;
      this.updateOrderDetailList.map((item) =>{
        if (item.consumptionTypeName === '快手团购'){
          kuaishoutuangou += item.received;
        }
        if (item.consumptionTypeName === '抖音团购'){
          douyintuangou += item.received;
        }
        if (item.consumptionTypeName === '美团团购'){
          meituantuangou += item.received;
        }
        if (item.consumptionTypeName === '口碑团购'){
          koubeituangou += item.received;
        }
        if (item.consumptionTypeName === '小程序团购'){
          xiaochengxutuangou += item.received;
        }
      })
      this.orgPayTypeList.map((item) => {
        if (item.payEnName === 'huiyuan'){
          huiyuan += item.money - 0;
        }
      })
      needPay = (this.updateOrderDetail.orderReceived -  meituantuangou - douyintuangou
        - koubeituangou - xiaochengxutuangou - huiyuan).toFixed(2);
      this.orgPayTypeList.map((item) => {
        if (item.payEnName !== 'huiyuan' && item.payEnName !== 'zengsonghuiyuan' && item.payEnName !== 'xianjin'
          && item.payEnName !== 'douyintuangou' && item.payEnName !== 'meituantuangou' && item.payEnName !== 'koubeituangou'
          && item.payEnName !== 'xiaochengxutuangou' && item.payEnName !== 'kuaishoutuangou'){
          if (item.money >= (needPay - money)){
            item.money = (needPay - money).toFixed(2);
          }
          money += item.money - 0;
        }
      })
      this.orgPayTypeList.map((item) => {
        if (item.payEnName === 'xianjin'){
          item.money = (needPay - money).toFixed(2);
        }
      })
    },
    setSkUpdateOrderPay(){
      let kuaishoutuangou = 0;
      let douyintuangou = 0;
      let meituantuangou=0;
      let koubeituangou=0;
      let xiaochengxutuangou=0;
      this.updateOrderDetailList.map((item) =>{
        if (item.consumptionTypeName === '快手团购'){
          kuaishoutuangou += item.received;
        }
        if (item.consumptionTypeName === '抖音团购'){
          douyintuangou += item.received;
        }
        if (item.consumptionTypeName === '美团团购'){
          meituantuangou += item.received;
        }
        if (item.consumptionTypeName === '口碑团购'){
          koubeituangou += item.received;
        }
        if (item.consumptionTypeName === '小程序团购'){
          xiaochengxutuangou += item.received;
        }
      })
      let money = 0;
      let needPay = (this.updateOrderDetail.orderReceived - kuaishoutuangou -  meituantuangou - douyintuangou - koubeituangou - xiaochengxutuangou).toFixed(2);
      this.orgPayTypeList.map((item) => {
        if (item.payEnName !== 'xianjin' && item.payEnName !== 'meituantuangou' && item.payEnName !== 'douyintuangou'
          && item.payEnName !== 'koubeituangou' && item.payEnName !== 'xiaochengxutuangou' && item.payEnName !== 'kuaishoutuangou'){
          money += item.money - 0;
        }
        if (item.payEnName === 'kuaishoutuangou') {
          item.money = kuaishoutuangou.toFixed(2);
        }
        if (item.payEnName === 'meituantuangou') {
          item.money = meituantuangou.toFixed(2);
        }
        if (item.payEnName === 'douyintuangou') {
          item.money = douyintuangou.toFixed(2);
        }
        if (item.payEnName === 'koubeituangou') {
          item.money = koubeituangou.toFixed(2);
        }
        if (item.payEnName === 'xiaochengxutuangou') {
          item.money = xiaochengxutuangou.toFixed(2);
        }
      })
      this.orgPayTypeList.map((item) => {
        if (item.payEnName === 'xianjin'){
          if ((needPay - money) < 0){
            item.money = 0;
          } else {
            item.money = (needPay - money).toFixed(2);
          }
        }
      })
    },
    serverSelectChange(val){
      this.selectServerList = val;
    },
    async loadLockDate(){
      const {data:res} = await this.$http.get(`/load/lock/date`)
      if(res.data != null){
        this.lockDate = res.data;
      }
    },
    disabledDate(time){
      // return time.getTime() <= Date.parse('2023-07-31') - 8.64e7;
      return time.getTime() <= Date.parse(this.lockDate) - 8.64e7;
    },
  },
  created() {
    this.loadLockDate();
    this.loadOrgPayType();
    this.loadOrderPayTypeTotalMoney();
    let orderId = this.$route.query.orderId;
    this.loadOrderDetail(orderId);
    this.value1 = this.$route.query.orderDate;
  }
}
</script>

<style scoped lang="less">
.container {
  height: 1500px;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
//flex: 1;
  width: auto;
//border: 1px solid;
  margin: 10px 0;
//width: 100px;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.el-table, .el-table__cell {
/deep/ th {
  padding: 2px ;
}
/deep/ td {
  padding: 2px ;
}
}
.box-card{
  margin: 10px 10px 10px 10px;
  height: 87%;
}
/deep/ .el-dialog{
  background: #fafaff !important;
}

/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}

/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}

/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  margin-bottom:0;
  color: #333 !important;
.el-dialog__title{
  color: #333;
}
.el-dialog__close{
  color: #333 !important;
}
}
.dialog-footer{
  display: flex;
  margin: 10px 10px 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/EditOrder.vue